/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

// fetching
export const DONE_FETCHING_SCHOOL_WIDGET_DATA =
  '@@nzr/schoolWidget/DONE_FETCHING_SCHOOL_WIDGET_DATA' as const
export const ERROR_FETCHING_SCHOOL_WIDGET_DATA =
  '@@nzr/schoolWidget/ERROR_FETCHING_SCHOOL_WIDGET_DATA' as const
export const START_FETCHING_SCHOOL_WIDGET_DATA =
  '@@nzr/schoolWidget/START_FETCHING_SCHOOL_WIDGET_DATA' as const
export const DONE_FETCHING_SCHOOL_WIDGET_SCHOOLS =
  '@@nzr/schoolWidget/DONE_FETCHING_SCHOOL_WIDGET_SCHOOLS' as const
export const ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS =
  '@@nzr/schoolWidget/ERROR_FETCHING_SCHOOL_WIDGET_SCHOOLS' as const
export const START_FETCHING_SCHOOL_WIDGET_SCHOOLS =
  '@@nzr/schoolWidget/START_FETCHING_SCHOOL_WIDGET_SCHOOLS' as const

// storing
export const CLEAR_SCHOOL_WIDGET_DATA = '@@nzr/schoolWidget/CLEAR_SCHOOL_WIDGET_DATA' as const
export const CLEAR_SCHOOL_WIDGET_SCHOOLS = '@@nzr/schoolWidget/CLEAR_SCHOOL_WIDGET_SCHOOLS' as const
export const SET_SCHOOL_WIDGET_DATA = '@@nzr/schoolWidget/SET_SCHOOL_WIDGET_DATA' as const
export const SET_SCHOOL_WIDGET_SCHOOLS = '@@nzr/schoolWidget/SET_SCHOOL_WIDGET_SCHOOLS' as const
export const SELECT_DISTRICT = '@@nzr/schoolWidget/SELECT_DISTRICT' as const
export const SELECT_SCHOOL_LEVEL = '@nzr/schoolWidget/SELECT_SCHOOL_LEVEL' as const
